import useLineItemsState, {
  LineItemStateKey,
} from "./use-line-items-state-context";

export function useCanValidate() {
  const { lineItemsState } = useLineItemsState();

  return Object.keys(lineItemsState).some((liStateKey) => {
    const lineItemState = lineItemsState[liStateKey];
    return Object.keys(lineItemState).some((lineItemStateKey) => {
      const lineItemStateValue =
        lineItemState[lineItemStateKey as LineItemStateKey];
      return lineItemStateValue.selectedQuantity > 0;
    });
  });
}
